var _rect, _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnChrome = function SvgIcnChrome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9658 15.3478C10.1617 15.3478 8.69385 13.8799 8.69385 12.0758C8.69385 10.2715 10.1617 8.80365 11.9658 8.80365C13.77 8.80365 15.238 10.2715 15.238 12.0758C15.238 13.8799 13.7701 15.3478 11.9658 15.3478Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3443 15.9292C12.8864 16.0958 12.4069 16.1799 11.9154 16.1799C10.951 16.1799 10.0095 15.8414 9.26446 15.2268C8.66005 14.7281 8.20958 14.0717 7.96132 13.3272L7.96 13.3228L4.35404 7.077C3.05859 9.06943 2.59893 11.4452 3.06005 13.7817C3.52972 16.1612 4.89772 18.2153 6.91228 19.566C7.96175 20.2694 9.12437 20.7386 10.3687 20.9611L13.3443 15.9292Z",
    fill: "#4AAE48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1462 7.98563C17.8941 3.45444 12.3951 1.60687 7.86401 3.85893C6.69131 4.44179 5.66086 5.26822 4.83789 6.27889L7.88403 11.5552C8.08172 10.0226 9.14251 8.66787 10.7135 8.17373C11.0925 8.05463 11.4869 7.99122 11.884 7.98563H20.1462Z",
    fill: "#EA3939"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9302 21.1006C14.2129 21.1006 16.3976 20.2445 18.081 18.6903C19.7731 17.1282 20.8008 15.0023 20.9746 12.7045C21.0739 11.3886 20.8789 10.0412 20.4102 8.80365H14.4523C15.4547 9.59716 16.0429 10.8098 16.037 12.0948C16.0328 13.02 15.7155 13.9292 15.1408 14.6592L11.3428 21.0817C11.5384 21.0942 11.7355 21.1006 11.9299 21.1006H11.9302Z",
    fill: "#FED14B"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnChrome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_chrome.576c44cf.svg";
export { ForwardRef as ReactComponent };